module.exports = __webpack_public_path__ + "static/media/scr_send_money_success_paste_reciept.460c1516.png";